import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deliveryRequests: {},
  productRequests: {},
  stockManagement: {},
  refreshList: false,
};

const jewelleryBuyerSlice = createSlice({
  name: "buyer",
  initialState,
  reducers: {
    addBuyer: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    addStockManagement: (state, action) => {
      const { data } = action.payload;
      state.stockManagement = data;
    },
    addProductRequests: (state, action) => {
      const { name, data } = action.payload;
      state[name] = data;
    },
    isRefreshList: (state, action) => {
      state.refreshList = action.payload;
    },
  },
});

export default jewelleryBuyerSlice;
export const {
  addBuyer,
  addStockManagement,
  addProductRequests,
  isRefreshList,
} = jewelleryBuyerSlice.actions;
